import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getInstrumentsStateTypesList = () => {
  return Helpers.get(Constants.INSTRUMENT_STATE_TYPES_URL);
};

const getAlertSeverityTypes = () => {
  return Helpers.get(Constants.ALERT_SEVERITY_TYPE_URL);
};

export const getData = () =>
  Promise.all([getAlertSeverityTypes(), getInstrumentsStateTypesList()]).then((res) =>
    res.map((r) => r.body)
  );

export const updateInstrumentStateType = (id, data) => {
  const url = `${Constants.INSTRUMENT_STATE_TYPES_URL}/${id}`;
  return Helpers.put(url, {}, data);
};
